import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "ja", // Force Japanese language
    fallbackLng: "ja",
    supportedLngs: ["ja"], // Only support Japanese

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    defaultNS: "translation",
    ns: ["translation"],

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
